import { footerLinks, tagCloud } from "@/mocks/homeNews";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50 border-t border-primary-800">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-xl">
                黑
              </span>
              <span>
                <span className="block font-heading text-2xl font-extrabold tracking-tight">每日黑料</span>
                <span className="block text-[11px] font-semibold tracking-[0.22em] text-primary-300 mt-1">
                  独家曝光 · 实时更新
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-primary-200/80 leading-relaxed">
              每日黑料曝光台，第一时间推送明星网红幕后事件与行业秘密。想抢在别人之前吃瓜，请锁定本站——每一条都为您精选。
            </p>
            <div className="mt-5 flex items-center gap-2 text-primary-200/70">
              <span className="text-xs">追更状态：</span>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-background-50">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-blink" />
                在线盯梢中
              </span>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-6">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="mb-3 text-sm font-bold text-background-50">{col.title}</h4>
                <ul className="flex flex-col gap-2">
                  {col.items.map((it) => (
                    <li key={it}>
                      <a
                        href="#lead"
                        className="text-sm text-primary-200/75 hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* 关键词信息区（自然分布） */}
        <div className="mt-8 flex flex-col gap-3 border-t border-primary-800/70 pt-6">
          <p className="text-xs font-semibold tracking-widest text-primary-300/80">每日黑料全站关键词</p>
          <div className="flex flex-wrap gap-2">
            {tagCloud.map((t) => (
              <span
                key={t}
                className="rounded-full bg-primary-800/50 px-3 py-1 text-xs text-primary-100/85 whitespace-nowrap"
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300/70">
            © 2026 每日黑料 曝光台 · 本站内容为虚构演示，展示用
          </p>
          <div className="flex items-center gap-4 text-xs text-primary-300/70">
            <a href="#faq" className="hover:text-background-50 transition-colors cursor-pointer">
              内容核实标准
            </a>
            <a href="#faq" className="hover:text-background-50 transition-colors cursor-pointer">
              隐私与申诉
            </a>
            <a href="#lead" className="hover:text-background-50 transition-colors cursor-pointer">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}